module.exports = __webpack_public_path__ + "static/img/kaozheng.ad01c2c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kaozheng.jpeg
// module id = 6iF3
// module chunks = 0